/** @format */

import { useRouter } from "@tanstack/react-router";
import { useCallback } from "react";

/**
 * Navigate that updates search params while staying on the current route.
 *
 * Unlike `useNavigate({ from: "/run/$runID" })`, this works correctly
 * on both the run page and child widget routes. The standard `from`
 * parameter causes TanStack Router to resolve the target path to the
 * parent `/run/$runID` route, dropping any child route segments.
 */
export function useSearchParamNavigate() {
  const router = useRouter();

  return useCallback(
    (opts: {
      to?: string;
      search?:
        | ((prev: Record<string, unknown>) => Record<string, unknown>)
        | Record<string, unknown>;
      replace?: boolean;
    }) => {
      // router.navigate without `from` resolves to the current matched
      // route via lightweightResult.fullPath, preserving child routes.
      return router.navigate(opts as never);
    },
    [router]
  );
}
